var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32,
    r: 32,
    fill: "#FDFEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.25 22H21.25C20.9185 22 20.6005 21.8683 20.3661 21.6339C20.1317 21.3995 20 21.0815 20 20.75C20 20.4185 20.1317 20.1005 20.3661 19.8661C20.6005 19.6317 20.9185 19.5 21.25 19.5H42.5C42.8315 19.5 43.1495 19.3683 43.3839 19.1339C43.6183 18.8995 43.75 18.5815 43.75 18.25C43.75 17.9185 43.6183 17.6005 43.3839 17.3661C43.1495 17.1317 42.8315 17 42.5 17H21.25C20.2554 17 19.3016 17.3951 18.5983 18.0983C17.8951 18.8016 17.5 19.7554 17.5 20.75V40.75C17.5 41.7446 17.8951 42.6984 18.5983 43.4017C19.3016 44.1049 20.2554 44.5 21.25 44.5H46.25C46.913 44.5 47.5489 44.2366 48.0178 43.7678C48.4866 43.2989 48.75 42.663 48.75 42V24.5C48.75 23.837 48.4866 23.2011 48.0178 22.7322C47.5489 22.2634 46.913 22 46.25 22ZM40.625 34.5C40.2542 34.5 39.8916 34.39 39.5833 34.184C39.275 33.978 39.0346 33.6851 38.8927 33.3425C38.7508 32.9999 38.7137 32.6229 38.786 32.2592C38.8584 31.8955 39.037 31.5614 39.2992 31.2992C39.5614 31.037 39.8955 30.8584 40.2592 30.786C40.6229 30.7137 40.9999 30.7508 41.3425 30.8927C41.6851 31.0346 41.978 31.275 42.184 31.5833C42.39 31.8916 42.5 32.2542 42.5 32.625C42.5 33.1223 42.3025 33.5992 41.9508 33.9508C41.5992 34.3025 41.1223 34.5 40.625 34.5Z",
    fill: "#0040BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionnew);
export default __webpack_public_path__ + "static/media/transactionnew.d3e50a0b0ad6748d75c18bd463795218.svg";
export { ForwardRef as ReactComponent };